<template>
  <div class="sf-product-card-horizontal">
    <component
      :is="linkComponentTag"
      v-focus
      :href="linkComponentTag === 'a' ? link : undefined"
      :to="link && linkComponentTag !== 'a' ? link : undefined"
      class="sf-product-card-horizontal__link sf-product-card-horizontal__link--image"
    >
      <div class="sf-product-card-horizontal__image-wrapper">
        <slot
          name="image"
          v-bind="{ image: product.image, title: product.title }"
        >
          <template v-if="Array.isArray(product.image)">
            <SfImage
              v-for="(picture, key) in product.image.slice(0, 2)"
              :key="key"
              class="sf-product-card-horizontal__picture"
              :src="picture"
              :alt="title"
              :width="imageWidth"
              :height="imageHeight"
            />
          </template>
          <SfImage
            v-else
            class="sf-product-card-horizontal__image"
            :src="product.image"
            :alt="product.title"
            :width="imageWidth"
            :height="imageHeight"
          />
        </slot>
      </div>
    </component>
    <div class="sf-product-card-horizontal__main">
      <div class="sf-product-card-horizontal__details">
        <component
          :is="linkComponentTag"
          :href="linkComponentTag === 'a' ? link : undefined"
          :to="link && linkComponentTag !== 'a' ? link : undefined"
          class="sf-product-card-horizontal__link"
        >
          <slot name="title" v-bind="{ title: product.title }">
            <h3 class="sf-product-card-horizontal__title">
              {{ product.title }}
            </h3>
            <p
              v-if="product.variantName"
              class="sf-product-card-horizontal__variant-name"
            >
              {{ product.variantName }}
            </p>
          </slot>
        </component>
        <slot name="description">
          <p class="sf-product-card-horizontal__description desktop-only">
            {{ product.description }}
          </p>
        </slot>
        <div class="sf-product-card-horizontal__configuration">
          <slot name="configuration" />
        </div>
      </div>
      <div class="sf-product-card-horizontal__actions-wrapper">
        <div class="flex-box-horizontal">
          <slot
            name="price"
            v-bind="{
              specialPrice: product.discountedPrice,
              regularPrice: product.basePrice,
            }"
          >
            <SfPrice
              v-if="product.basePrice != null"
              class="sf-product-card-horizontal__price"
              :regular="product.basePrice | price"
              :special="product.discountedPrice | price"
            />
          </slot>
          <div
            v-if="isCartEnabled"
            class="sf-product-card-horizontal__add-to-cart"
          >
            <slot name="add-to-cart">
              <SfAddToCart
                :qty="product.qty"
                :product="product"
                class="sf-product-card-horizontal__add-to-cart"
                @input="$emit('input:add-to-cart', $event)"
                @click="$emit('click:add-to-cart')"
              />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { focus } from "../../../utility/directives/focus-directive.js";
import SfPrice from "../../atoms/SfPrice/SfPrice.vue";
import SfIcon from "../../atoms/SfIcon/SfIcon.vue";
import SfProperty from "../../atoms/SfProperty/SfProperty.vue";
import SfRating from "../../atoms/SfRating/SfRating.vue";
import SfImage from "../../atoms/SfImage/SfImage.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfAddToCart from "../../molecules/SfAddToCart/SfAddToCart.vue";
import SfProductOption from "../../molecules/SfProductOption/SfProductOption.vue";
export default {
  name: "SfProductCardHorizontal",
  components: {
    SfPrice,
    SfRating,
    SfImage,
    SfIcon,
    SfButton,
    SfAddToCart,
    SfProductOption,
    SfProperty,
  },
  directives: {
    focus: focus,
  },
  model: {
    prop: "qty",
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    imageWidth: {
      type: [String, Number],
      default: 140,
    },
    imageHeight: {
      type: [String, Number],
      default: 140,
    },
    link: {
      type: [String, Object],
      default: "",
    },
    linkTag: {
      type: String,
      default: undefined,
    },
    isAddedToCart: {
      type: Boolean,
      deafult: false,
    },
    addToCartDisabled: {
      type: Boolean,
      default: false,
    },
    wishlistIcon: {
      type: [String, Array, Boolean],
      default: "heart",
    },
    isCartEnabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    linkComponentTag() {
      if (this.linkTag) {
        return this.linkTag;
      }
      if (this.link) {
        return typeof this.link === "object" || this.$router
          ? "router-link"
          : "a";
      }
      return "div";
    },
  },
};
</script>
<style lang="scss">
@import "~@lib/styles/components/organisms/SfProductCardHorizontal.scss";
</style>
